import styled from 'styled-components';

import BtnContainer from '../BtnContainer';
import AbsLayer from './AbsLayer';

const TextInheritInteractionLayer = styled(AbsLayer)`
  background-color: currentColor;
  opacity: 0;

  ${BtnContainer}:hover & {
    opacity: var(--theme-hover-tint);
  }
  ${BtnContainer}:focus-visible & {
    opacity: var(--theme-focus-tint);
  }
  ${BtnContainer}[data-active] & {
    opacity: var(--theme-focus-tint);
  }
  ${BtnContainer}:active & {
    opacity: var(--theme-pressed-tint);
  }
`;

export default TextInheritInteractionLayer;
